import { LOCALES } from "@marketplace/i18n";

export const clientCredentialsFormI18n = {
    [LOCALES.ENG]: {
        developer_myprofile_clientcredential_patientpofile_userid: 'Patient ID',
        developer_myprofile_clientcredential_patientpofile_password: 'Password',
        developer_myprofile_clientcredential_ehrpofile_userid: 'Provider ID',
        developer_myprofile_clientcredential_ehrpofile_password: 'Password',
        developer_myprofile_clientcredential_get_credentials: 'Get Credentials',

    
    }
}